import React from 'react';

import { Space, Typography, Button } from 'antd';

import BoxRemoteIcon from '@/components/icons/BoxRemoteIcon';

const { Text } = Typography;

interface AssistanceSectionProps {
  onRemoteControl: () => void;
  lpui: string;
}

export const AssistanceSection: React.FC<AssistanceSectionProps> = ({
  onRemoteControl,
}) => (
  <Space direction="vertical" size={16} style={{ width: '100%' }}>
    <Text
      style={{
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '125%',
      }}
    >
      Assistance
    </Text>

    {/* BOX Security Remote control button */}
    <Button
      color="primary"
      variant="link"
      onClick={onRemoteControl}
      icon={<BoxRemoteIcon />}
    >
      <Text
        style={{
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: '135%',
          textDecoration: 'underline',
          color: '#38A169',
        }}
      >
        BOX Security Remote control
      </Text>
    </Button>
  </Space>
);
